export const decodeOrThrow = <T>(validate: (payload: unknown) => T | null, payload: unknown): T => {
  const result = validate(payload);

  if (result === null) {
    throw new Error('Validation failed'); // Puoi personalizzare il messaggio di errore
  }

  return result;
};
